import { render, staticRenderFns } from "./addProducts.vue?vue&type=template&id=0303acd8&scoped=true"
import script from "./addProducts.vue?vue&type=script&lang=js"
export * from "./addProducts.vue?vue&type=script&lang=js"
import style0 from "./addProducts.vue?vue&type=style&index=0&id=0303acd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0303acd8",
  null
  
)

export default component.exports